<template>
    <div class="section fade-in">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col cols="12" class="text-center">
                    <h2 class="section__header-title text-h3 font-weight-bold">AI Agents via Voice and Text</h2>
                    <h2 class="text-subtitle-1">Supercharge your team with AI support on SMS, Web and Voice channels</h2>
                </v-col>
                
            </v-row>
            <v-row cols="12" class="px-10">
                <v-col cols="12" md="4" class="d-flex flex-column align-center justify-center">
                    <v-card class="mb-10">
                        <v-card-title>ID&V Agents</v-card-title>
                        <v-card-text>Use AI to ID customers to pass to your contact centre agents.</v-card-text>
                    </v-card>
                    <v-card>
                        <v-card-title>Missed payments</v-card-title>
                        <v-card-text>Automated reminders when payment arrangements lapse.</v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4" class="d-flex align-center justify-space-around">
                    <v-img
                    class="hero-banner__image px-sm-6 ai-img"
                    src="../assets/img/ai-chat.jpg"
                    max-width="240"
                    alt="Yabbr Platform"
                    />
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-column align-center justify-center">
                    <v-card class="mb-10">
                        <v-card-title>Payment Negotiation</v-card-title>
                        <v-card-text>Enable customers to self-serve payment arrangements through negotiation with an AI Agent.</v-card-text>
                    </v-card>
                    <v-card>
                        <v-card-title>Information collection</v-card-title>
                        <v-card-text>Gather information to support applications and claims, along with support documentation.</v-card-text>
                    </v-card>
                </v-col>
            </v-row>        
        </v-container>
    </div>
  </template>
  
<script>
export default {
    name: 'AiChat',
}
</script>

<style lang="scss">
.ai-img {
    height: 100%;
    width: 100%;
    object-fit: cover;
}

.fade-in {
    animation: fadeIn 1s ease-out forwards;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(100px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
  